import React from 'react'
import Modal from '../../../shared/Modal'
import {Button} from '../../../shared/Button'

const {REACT_APP_GOOGLE_API_KEY: API_KEY} = process.env

const formatAddress = ({address, city, state, zipCode}) =>
  [address, `${city}, ${state} ${zipCode}`].filter(Boolean).join(', ')

const Token = ({value, changed}) => (
  <span
    style={{
      fontWeight: changed ? 600 : 400,
      backgroundColor: changed ? '#FEF3C7' : 'transparent',
      borderRadius: 3,
      padding: changed ? '0 2px' : 0,
    }}
  >
    {value}
  </span>
)

const optionStyle = ({selected, disabled}) => ({
  display: 'flex',
  gap: 10,
  padding: 12,
  border: `1px solid ${selected ? '#2563EB' : '#E5E7EB'}`,
  borderRadius: 8,
  cursor: disabled ? 'default' : 'pointer',
  opacity: disabled ? 0.6 : 1,
})

// Confirm-your-address dialog shown when Google's Address Validation API
// returns SUGGESTED (plausible but not confirmed) instead of CONFIRMED.
// Only the recommended correction can be accepted here — if the user wants
// what they originally typed, they must go Back and re-enter it, rather
// than being able to select the unconfirmed address directly.
export function AddressSuggestionModal({suggestion, onConfirm}) {
  if (!suggestion) return null

  const {original, recommended, message} = suggestion
  const addressChanged = original.address !== recommended.address
  const cityChanged = original.city !== recommended.city
  const stateChanged = original.state !== recommended.state
  const zipChanged = original.zipCode !== recommended.zipCode

  const mapUrl =
    API_KEY && recommended.lat != null && recommended.lng != null
      ? `https://maps.googleapis.com/maps/api/staticmap?center=${recommended.lat},${recommended.lng}&zoom=15&size=520x140&scale=2&markers=color:red|${recommended.lat},${recommended.lng}&key=${API_KEY}`
      : null

  return (
    <Modal
      isOpen
      title="Confirm Address"
      subtitle={message}
      size="md"
      onClose={() => onConfirm('cancel')}
      footer={
        <>
          <Button variant="secondary-blue" onClick={() => onConfirm('cancel')}>
            Back
          </Button>
          <Button
            variant="solid-gradiant"
            onClick={() => onConfirm('recommended')}
          >
            Confirm
          </Button>
        </>
      }
    >
      <div style={{display: 'flex', flexDirection: 'column', gap: 12}}>
        <div style={optionStyle({selected: false, disabled: true})}>
          <input type="radio" name="address-suggestion" disabled />
          <div>
            <div style={{fontWeight: 600, marginBottom: 4}}>
              What you entered
            </div>
            <div>{formatAddress(original)}</div>
          </div>
        </div>

        <div style={optionStyle({selected: true, disabled: false})}>
          <input type="radio" name="address-suggestion" checked readOnly />
          <div style={{width: '100%'}}>
            <div style={{fontWeight: 600, marginBottom: 4}}>Recommended</div>
            {recommended.address && (
              <div>
                <Token value={recommended.address} changed={addressChanged} />
              </div>
            )}
            <div>
              <Token value={recommended.city} changed={cityChanged} />
              {', '}
              <Token value={recommended.state} changed={stateChanged} />{' '}
              <Token value={recommended.zipCode} changed={zipChanged} />
            </div>
            {mapUrl && (
              <img
                src={mapUrl}
                alt="Map preview of recommended address"
                style={{marginTop: 8, width: '100%', borderRadius: 6}}
              />
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}
